import { WindowContentService } from '@core/components/sidebar/components/flowpilot/window/services/window-content.service';
import { FlowpilotChatService } from '@core/components/sidebar/components/flowpilot/window/content/services/flowpilot-chat.service';
import { FlowpilotSidebarService } from '@core/components/sidebar/components/flowpilot/window/content/services/flowpilot-sidebar.service';
import { FlowpilotPopUpService } from '@core/components/sidebar/components/flowpilot/window/content/services/flowpilot-pop-up.service';

export const provideFlowpilotServices = () => {
  return [
    WindowContentService,
    FlowpilotChatService,
    FlowpilotSidebarService,
    FlowpilotPopUpService,
  ];
};
